/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Office_TemplateInputs */

const cs_settings_office_template = /** @type {(inputs: Settings_Office_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šablona webu`)
};

const en_settings_office_template = /** @type {(inputs: Settings_Office_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Website template`)
};

/**
* | output |
* | --- |
* | "Website template" |
*
* @param {Settings_Office_TemplateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_office_template = /** @type {((inputs?: Settings_Office_TemplateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Office_TemplateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_office_template(inputs)
	return cs_settings_office_template(inputs)
});